import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

import { Icon } from "../../icon/Icon";
import { openUnblockModal } from "../devices.actions";
import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";

export const useUnblockDeviceMenuItem = (device) => {
  const dispatch = useDispatch();

  return {
    id: "unblock",
    content: (
      <Fragment>
        <Icon icon="fa-solid fa-unlock" />
        <span>
          <FormattedMessage id="unblock" />
        </span>
      </Fragment>
    ),
    action: () => dispatch(openUnblockModal(device)),
  };
};

export const UnblockDeviceDropdownItem = ({ device, ...props }) => {
  const { id, content, action } = useUnblockDeviceMenuItem(device);

  return (
    <LazyLoadDropdownItem id={id} action={action} {...props}>
      {content}
    </LazyLoadDropdownItem>
  );
};

export const UnblockDeviceModalItem = ({ device }) => {
  const { id, content, action } = useUnblockDeviceMenuItem(device);

  return (
    <DeviceActionsModalItem id={id} action={action}>
      {content}
    </DeviceActionsModalItem>
  );
};
